import { MailSortHelper } from 'owa-mail-list-store';
import { getFindItemShape, FindConversationShapeName } from 'owa-mail-store';
/**
 * Create the table query to load group mail
 * @param groupId the groupId (group smtp address)
 * @param listViewType the list view type
 * @return tableQuery the tableQuery that needed to load group mail
 */
export default function createGroupMailTableQuery(groupId, listViewType) {
    var requestShapeName;
    switch (listViewType) {
        case 0 /* Conversation */:
            requestShapeName = FindConversationShapeName;
            break;
        case 1 /* Message */:
            requestShapeName = getFindItemShape();
            break;
    }
    var groupMailTableQuery = {
        categoryName: null,
        folderId: groupId,
        focusedViewFilter: -1 /* None */,
        listViewType: listViewType,
        viewFilter: 'All',
        sortBy: MailSortHelper.getDefaultSortBy(),
        requestShapeName: requestShapeName,
        type: 2 /* Group */,
        shouldTryToUseSessionDataResponse: false,
        scenarioType: 'group',
    };
    return groupMailTableQuery;
}
//# sourceMappingURL=createGroupMailTableQuery.js.map